import bindScroll from 'helpers/bindScroll';
import onNowLandscapeCarousel from 'components/onNowLandscapeCarousel';
import GeoLocationService from 'services/GeoLocationService';
import DMAStorageService from '../services/DMAStorageService';

export default function onNowCarousel(onNowCarousel, objs) {
    let userlocation = null;

    /**
     * @type {GeoLocationService}
     */
    let GeoLocation = new GeoLocationService();

    /* Creating a new instance of the DMAStorageService class. */
    let DMAStorage = new DMAStorageService();

    try {
        let timezone_offset_minutes = new Date().getTimezoneOffset();
        timezone_offset_minutes =
            timezone_offset_minutes === null || timezone_offset_minutes === undefined
                ? 0
                : timezone_offset_minutes;

        objs.push({
            wrapper: onNowCarousel,
            init: function () {
                /**
                 * Check current viewer location
                 * @private
                 */
                GeoLocation.fetchLocation()
                    .then((location) => {
                        userlocation = location;
                        onNowCarousel.on('init', () => {
                            onNowCarousel.removeClass('hidden');
                        });

                        let currentLocation = DMAStorage.getCurrentLocation();
                        let [dma, stationId] = DMAStorage.getDMAStationIdStringOnNow();

                        onNowCarousel.on('setPosition', () => {
                            onNowCarousel.ellipsify();
                        });

                        let loc = {};
                        if (currentLocation == null) {
                            loc = {
                                lat: location.coords.latitude,
                                lon: location.coords.longitude,
                            };
                            DMAStorage.setCurrentLocation(loc);
                            dma = null;
                        } else {
                            loc = currentLocation;
                            if (
                                loc.lat != location.coords.latitude ||
                                loc.lon != location.coords.longitude
                            ) {
                                loc = {
                                    lat: location.coords.latitude,
                                    lon: location.coords.longitude,
                                };
                                DMAStorage.setCurrentLocation(loc);
                                dma = null;
                            }
                        }
                        let params = {
                            parentContainer: onNowCarousel,
                            options: {
                                endPoint: CBS.Registry.region.prefix + '/carousels/homepage/onnow/',
                                params: {
                                    timeZoneOffset: timezone_offset_minutes,
                                    latitude: userlocation.coords.latitude,
                                    longitude: userlocation.coords.longitude,
                                    dma: dma ?? null,
                                    stationId: stationId ?? null,
                                },
                                fetchData: true,
                            },
                        };
                        if (dma != null) {
                            onNowLandscapeCarousel(params);
                        } else {
                            fetch(
                                CBS.Registry.region.prefix +
                                    '/live-tv/dma/' +
                                    location.coords.latitude +
                                    '/' +
                                    location.coords.longitude,
                            )
                                .then(function (response) {
                                    return response.json();
                                })
                                .then(function (resultData) {
                                    if (resultData.result.dmas !== undefined && resultData.result.dmas !== null){
                                        let paramDmas = '';
                                        let paramStationIds = '';
                                        let storageDma = [];
                                        
                                        resultData.result.dmas.forEach((dma) => {
                                            paramDmas += paramDmas == '' ? dma.dma : ',' + dma.dma;
                                            paramStationIds +=
                                                paramStationIds == ''
                                                    ? dma.stationId
                                                    : ',' + dma.stationId;
                                            storageDma.push({
                                                dma: dma.dma,
                                                stationId: dma.stationId,
                                                stationSlug: dma.callSignId.toLowerCase(),
                                            });
                                        });
                                        DMAStorage.setStorageDMA(storageDma);
                                        params.options.params.dma = paramDmas;
                                        params.options.params.stationId = paramStationIds;
                                    }
                                    onNowLandscapeCarousel(params);
                                });
                        }
                    })
                    .catch(() => {
                        console.log('Failed to get user location');
                    });
            },
        });
    } catch (e) {}
}
